/** Nomes de status da API (Services/AdminSalesStatus) e apresentação na UI. Usado por /vendas-admin e /grafica-admin. */
export const SALES_STATUS = {
  aguardaDanfe: 'Aguarda DANFE (.pdf)',
  aguardaXml: 'Aguarda NFe (.xml)',
  aguardaEtiqueta: 'Aguarda Carta remessa',
  aguardaProducao: 'Aguardando produção',
  emProducao: 'Em produção',
  enviado: 'Enviado',
  entregue: 'Entregue',
  finalizado: 'Finalizado',
} as const;

export const SALES_STATUS_FLOW: string[] = [
  SALES_STATUS.aguardaDanfe,
  SALES_STATUS.aguardaXml,
  SALES_STATUS.aguardaEtiqueta,
  SALES_STATUS.aguardaProducao,
  SALES_STATUS.emProducao,
  SALES_STATUS.enviado,
  SALES_STATUS.entregue,
  SALES_STATUS.finalizado,
];

/** Rótulo curto para a faixa de etapas. */
export function stageLabel(status: string): string {
  switch (status) {
    case SALES_STATUS.aguardaDanfe: return 'Aguarda DANFE';
    case SALES_STATUS.aguardaXml: return 'Aguarda XML';
    case SALES_STATUS.aguardaEtiqueta: return 'Aguarda etiqueta';
    case SALES_STATUS.aguardaProducao: return 'Aguarda produção';
    case SALES_STATUS.finalizado: return 'Finalizado (digital)';
    default: return status;
  }
}

/** Classe do chip de status. */
export function statusClass(status: string): string {
  switch (status) {
    case SALES_STATUS.aguardaDanfe:
    case SALES_STATUS.aguardaXml: return 'chip chip-warn';
    case SALES_STATUS.aguardaEtiqueta:
    case SALES_STATUS.aguardaProducao: return 'chip chip-pend';
    case SALES_STATUS.emProducao:
    case SALES_STATUS.enviado: return 'chip chip-info';
    case SALES_STATUS.entregue:
    case SALES_STATUS.finalizado: return 'chip chip-ok';
    default: return 'chip';
  }
}

/** Duração em horas → "menos de 1 h", "14 h", "2,5 d". */
export function durationLabel(hours: number | null | undefined): string {
  if (hours === null || hours === undefined || isNaN(hours) || hours < 0) return '—';
  if (hours < 1) return 'menos de 1 h';
  if (hours < 48) return `${Math.round(hours)} h`;
  return `${(hours / 24).toFixed(1).replace('.', ',')} d`;
}

export const CORREIOS_SERVICES: { code: string; name: string }[] = [
  { code: '03298', name: 'PAC (03298)' },
  { code: '03220', name: 'SEDEX (03220)' },
  { code: '03280', name: 'SEDEX 10 (03280)' },
  { code: '20192', name: 'Módico (20192)' },
];

export const PAYMENT_METHODS: { id: number; name: string }[] = [
  { id: 3, name: 'PIX' },
  { id: 2, name: 'Cartão parcelado' },
  { id: 1, name: 'Cartão recorrente' },
  { id: 4, name: 'Marketplace (Amazon)' },
];

/** Canal de venda (filtro "Canal" da listagem). */
export const SALES_CHANNELS: { value: '' | 'plataforma' | 'marketplace'; label: string }[] = [
  { value: '', label: 'Todos' },
  { value: 'plataforma', label: 'Plataforma' },
  { value: 'marketplace', label: 'Marketplace (Amazon)' },
];

export const TRACKING_CODE_REGEX = /^[A-Z]{2}\d{9}[A-Z]{2}$/;
